import { Card, Center, Heading } from "@chakra-ui/react";
import React, { useState } from "react";
import CustomButton from "../../components/ButtonComp";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import CustomInput from "../../components/CustomInput";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import { baseUrl } from "../../utils/utils";

const AddBlkLpgSchema = Yup.object().shape({
  company_name: Yup.string()
    .required("Company name is required")
    .oneOf(
      ["IOCL", "BPCL", "HPCL", "SUPERGAS", "TOTALGAS", "Gogas", "Allied", "AEGIS"],
      "Please select a valid company"
    ),
  uuid: Yup.string()
    .required("Product code is required")
    .min(6, "Product code must be at least 6 characters")
    .max(8, "Product code must be less than 8 characters"),
  price: Yup.number()
    .typeError("Price must be a valid number")
    .required("Price is required")
    .positive("Price must be greater than 0")
    .min(0.01, "Price must be at least ₹0.01")
    .max(9999999.99, "Price cannot exceed ₹99,99,999.99")
    .test(
      "decimal-places",
      "Price can have at most 2 decimal places",
      (value) => value === undefined || /^\d+(\.\d{1,2})?$/.test(String(value))
    ),
});

const AddBlkLpg = () => {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);


   const typeOptions = [
    { value: "IOCL", label: "IOCL" },
    { value: "BPCL", label: "BPCL" },
    { value: "HPCL", label: "HPCL" },
    { value: "SUPERGAS", label: "SUPERGAS" },
    { value: "TOTALGAS", label: "TOTALGAS" },
    { value: "Gogas", label: "Gogas" },
    { value: "Allied", label: "Allied" },
    { value: "AEGIS", label: "AEGIS" },
  ];

  
  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      setIsSubmitting(true);

      const formData = new FormData();
      formData.append("action", "create");
      formData.append("product_name", values.company_name.trim());
      formData.append("category", "BLK_LPG");
      formData.append("type", "");
      formData.append("capacity", "0");
      formData.append("description", values.company_name.trim());
      formData.append("hsn", "");
      formData.append("uom", "");
      formData.append("gst", "0");
      formData.append("mat", "");
      formData.append("wt", "0");
      formData.append("ht", "0");
      formData.append("dia", "0");
      formData.append("thick", "0");
      formData.append("wc", "0");
      formData.append("rsp", parseFloat(values.price).toFixed(2));
      formData.append("fixed_rate", "0");
      formData.append("uuid", values.uuid);
      formData.append("unit_rate", parseFloat(values.price).toFixed(2));
      formData.append("discount", "0.00");
      formData.append("security_deposit", "0");

      const response = await fetch(baseUrl + "product.php", {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (!response.ok || result.status === "error") {
        throw new Error(
          result.message || result.error || "Failed to add Bulk LPG"
        );
      }

      toast.success("Bulk LPG added successfully");
      resetForm();
      navigate("/blk-lpg", { replace: true });
    } catch (error) {
      console.error("Error adding bulk lpg:", error);
      toast.error(error.message || "Failed to add Bulk LPG. Please try again.");
    } finally {
      setIsSubmitting(false);
      setSubmitting(false);
    }
  };

  return (
    <>
      <Card
        display="flex"
        flexDirection="row"
        alignItems="center"
        justify="space-between"
        paddingInline={5}
        paddingBlock={2}
      >
        <Heading fontSize="xl">Add Bulk LPG</Heading>
        <CustomButton
          icon={<BiArrowBack color="#fff" />}
          title="Back"
          height="30px"
          b_color="#000"
          onClick={() => navigate(-1)}
        />
      </Card>

      <Formik
        initialValues={{ company_name: "", uuid: "", price: "" }}
        validationSchema={AddBlkLpgSchema}
        onSubmit={handleSubmit}
        validateOnChange={true}
        validateOnBlur={true}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          setFieldValue,
          isSubmitting: formikSubmitting,
          isValid,
          dirty,
          submitForm,
        }) => (
          <Form>
            <Card paddingInline={5}>
              <CustomInput
                label1="Company Name"
                placeholder1="Select company name"
                value1={values.company_name}
                onChange1={handleChange("company_name")}
                onBlur1={handleBlur("company_name")}
                select1={true}
                options1={typeOptions}
                error1={touched.company_name && errors.company_name}
                label2="Price (RSP)"
                placeholder2="Enter price (e.g. 100.00)"
                value2={values.price}
                onChange2={(e) => {
                  const val = e.target.value;
                  if (val === "" || /^\d*\.?\d{0,2}$/.test(val)) {
                    setFieldValue("price", val);
                  }
                }}
                onBlur2={handleBlur("price")}
                error2={touched.price && errors.price}
                required2={true}
              />

              <CustomInput
                label1={"Product Code"}
                placeholder1={"Enter 6-8 character product code"}
                value1={values.uuid}
                onChange1={handleChange("uuid")}
                onBlur1={handleBlur("uuid")}
                error1={touched.uuid && errors.uuid}
                required1={true}
              />

              <Center marginBlock={5}>
                <CustomButton
                  title={
                    isSubmitting || formikSubmitting
                      ? "Submitting..."
                      : "Add Bulk LPG"
                  }
                  onClick={submitForm}
                  disabled={isSubmitting || formikSubmitting || !isValid || !dirty}
                />
              </Center>
            </Card>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default AddBlkLpg;
